.tile {
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
  padding: var(--space-5);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  background: linear-gradient(to bottom, var(--bg-surface), var(--bg-card));
  overflow: hidden;
  text-align: left;
}

/* Series colour as a top rule, so the tile reads against its chart */
.accented::before {
  content: '';
  position: absolute;
  inset: 0 0 auto;
  height: 3px;
  background: var(--accent);
}

.toggle {
  font: inherit;
  color: inherit;
  cursor: pointer;
  transition: border-color var(--duration-fast), background var(--duration-fast);
}

.toggle:hover {
  border-color: var(--border-strong);
}

.toggle:focus-visible {
  outline: 2px solid var(--accent-secondary);
  outline-offset: 2px;
}

/* User-set → gold */
.toggle[data-selected] {
  border-color: var(--accent-secondary);
  background: color-mix(in srgb, var(--accent-secondary) 8%, var(--bg-card));
}

.label {
  font-size: var(--text-xs);
  font-weight: var(--weight-bold);
  letter-spacing: var(--tracking-caps);
  text-transform: uppercase;
  color: var(--text-secondary);
}

.value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: var(--font-display);
  font-size: 38px;
  line-height: 1;
  color: var(--text-primary);
}

.sub {
  font-size: var(--text-sm);
  color: var(--text-muted);
}

.facts {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-4);
  margin-top: var(--space-1);
  font-size: var(--text-sm);
  font-weight: var(--weight-semi);
  font-variant-numeric: tabular-nums;
  color: var(--text-primary);
}

.factLabel {
  font-weight: var(--weight-regular, 400);
  color: var(--text-muted);
}
